import React, { Component } from 'react';
import { connect } from 'react-redux';
import axios from 'axios';
import Moment from 'react-moment';
import { Layout, Spin, Table, Row, Col, Tag, Divider } from 'antd';

import { fetchMenuAction } from '../../store/actions/leftSideMenu';
import SearchForm from '../SearchForm';
import { Constant } from '../../config';

const { Content } = Layout;

class Gateway extends Component {
	state = {
		loading: false,
		dataSource: []
	}

	columns = [
		{
      title: 'ประเทศ',
      dataIndex: 'country_name',
      render: (text, record)=>{
      	return (
      		<span>
      			<span style={{fontWeight:'bold'}}>{text}</span><br />
      			<Tag color="blue">Region Code: {record.region_code}</Tag>
      			<Tag color="orange">แก้ไขล่าสุดเมื่อ: <Moment unix tz="Etc/UTC" format="MMM DD YYYY HH:mm:ss">{record.updated}</Moment></Tag>
      		</span>
      	)
      }
    },
    {
    	title: 'Gateway',
    	dataIndex: 'gateway_id',
    	render: (text, record)=>{
    		return (
    			<span style={{fontWeight:'bold'}}>
    				{
    					(record.gateway_detail && record.gateway_detail.name) || 
    					(record.gateway_voice_detail && record.gateway_voice_detail.name) ||
    					text
    				}
    			</span>
    		)
    	}
    }
	]
  columnsMobile = [
    {
      title: 'ประเทศ',
      dataIndex: 'country_name',
      render: (text, record)=>{
        return (
          <span>
            <span style={{fontWeight:'bold'}}>{text}</span><br />
            <Tag color="blue">Region Code: {record.region_code}</Tag>
            <Tag color="orange">แก้ไขล่าสุดเมื่อ: <Moment unix tz="Etc/UTC" format="MMM DD YYYY HH:mm:ss">{record.updated}</Moment></Tag>
            <Divider className="my-divider" dashed orientation="left">Gateway</Divider>
            <div>
              {
                (record.gateway_detail && record.gateway_detail.name) || 
                (record.gateway_voice_detail && record.gateway_voice_detail.name) ||
                record.gateway_id
              }
            </div>
          </span>
        )
      }
    },
  ]
	currentServiceType = ""
	currentPage = 1
  currentSearch = ""
  limit = 10
  totalRows = 0

	componentWillMount(){
		this.currentServiceType = this.props.match.params[0]
		this.props.fetchMenuAction("gateway", `${this.currentServiceType}-country-gateway`)
		this.setState({loading: true})
	}

	async componentDidMount(){
		this.setState({
			loading: false,
			dataSource: await this._getListCountryGateway()
		})
	}

	componentDidUpdate = async (prevProps, prevState) => {
    if (this.props.match.params && prevProps.match.params && this.props.match.params[0] !== prevProps.match.params[0]){
    	this.setState({loading: true})
      this.currentServiceType = this.props.match.params[0]
			this.props.fetchMenuAction("gateway", `${this.currentServiceType}-country-gateway`)
      this.setState({
        dataSource: await this._getListCountryGateway(),
        loading: false,
      })
    }
  }

	searchCountryGateway = (fd) => {
		fd.validateFields(async (err, values)=>{
      if (err)
        return

      this.setState({loading: true})

      this.currentPage = 1
      this.currentSearch = values.searchTxt
      this.limit = 10
      this.setState({
        dataSource: await this._getListCountryGateway(1, 10, this.currentSearch),
        loading: false
      })
    })
	}

	resetSerchCountryGateway = async () => {
		this.setState({loading: true})
    this.currentPage = 1
    this.currentSearch = ""
    this.setState({
      dataSource: await this._getListCountryGateway(),
      loading: false
    })
	}

	changePage = async (page, limit) => {
		this.setState({loading: true})
  	this.currentPage = page
  	this.limit = limit
  	this.setState({
      dataSource: await this._getListCountryGateway(
        page,
        limit,
        this.currentSearch,
      ),
      loading: false
    })
	}

	_getListCountryGateway = async (page=1, limit=10, search="")=>{
		let url = Constant.MATCH_COUNTRY_GATEWAY_API+"?page="+page+"&limit="+limit+"&search="+search+"&service_type="+this.currentServiceType
    let opt = {
      url,
      method: "GET",
      headers: {
        'Authorization': "Bearer "+localStorage.getItem(Constant.SessionKey)
      },
    }
    let resp

    try {
    	resp = await axios(opt)
    } catch(err) {
    	resp = err.response
    }

    if (!resp.data) {
    	console.log(resp.data)
    	return []
    }

    if (resp.data.error) {
    	console.log(resp.data.error)
    	return []
    }

    this.totalRows = resp.data.total_rows || 0

    return resp.data.data
	}

	render() {
    let propsTable = {
      className: "my-table",
      columns: this.columns,
      dataSource: this.state.dataSource,
      rowKey: "id",
      pagination: {
        pageSize:this.limit, 
        total:this.totalRows, 
        current:this.currentPage, 
        onChange:this.changePage, 
        size:"small"
      }
    }
    let propsTableForMobile = Object.assign({}, propsTable)
    propsTableForMobile.className = "my-table-mobile"
    propsTableForMobile.columns = this.columnsMobile

		return (
			<Layout className="my-layout">
				<Spin spinning={this.state.loading} tip="กำลังโหลดข้อมูล...">
					<Content
            style={{
              background: '#fff',
              padding: 24,
              margin: '16px 0',
              minHeight: 300,
            }}
          >
            <h2>ตั้งค่าระบบ : {this.currentServiceType.toUpperCase()} Gateway แต่ละประเทศ</h2>
            <Row className="utility-bar">
              <Col span={12}></Col>
              <Col span={12}><SearchForm fn={this.mySearch} fnReset={this.resetSearch} /></Col>
            </Row>
            <Row className="utility-bar-mobile">
              <SearchForm fn={this.searchCountryGateway} fnReset={this.resetSerchCountryGateway} />
            </Row>
            <Table {...propsTable} />
            <Table {...propsTableForMobile} />
          </Content>
				</Spin>
			</Layout>
		)
	}
}

const mapDispatchToProps = dispatch => {
  return {
    fetchMenuAction: (menuParentKey, menuKey) => dispatch(fetchMenuAction(menuParentKey, menuKey))
  }
}

export default connect(null, mapDispatchToProps)(Gateway)



// WEBPACK FOOTER //
// ./src/containers/Gateway/index.js